import type { Market, SalesInfo, SettleInfo } from '@/types/statistics';
import { SalesInfoInitial, SettleInfoInitial } from '@/types/statistics';

export interface StatisticsDailyCacheValue {
  dailyMarketList: Market[];
  dailySalesInfo: SalesInfo;
  dailySettleInfo: SettleInfo;
}

interface StatisticsDailyResponseItem {
  MarketList?: Market[];
  SalesInfo?: SalesInfo;
  SettleInfo?: SettleInfo;
}

export const getStatisticsDailyCacheKey = (dateString: string) => dateString.slice(0, 10);

export const getShouldRefreshStatisticsDailyCache = (selectedDate: string, todayDate: string) =>
  getStatisticsDailyCacheKey(selectedDate) === getStatisticsDailyCacheKey(todayDate);

export const createStatisticsDailyCacheValue = (
  dailyStatistics?: StatisticsDailyResponseItem,
): StatisticsDailyCacheValue => ({
  dailyMarketList: dailyStatistics?.MarketList ?? [],
  dailySalesInfo: dailyStatistics?.SalesInfo ?? SalesInfoInitial,
  dailySettleInfo: dailyStatistics?.SettleInfo ?? SettleInfoInitial,
});
